import { render, staticRenderFns } from "./ProductSetSlidegroup.vue?vue&type=template&id=64a2bcb4&scoped=true"
import script from "./ProductSetSlidegroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSetSlidegroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductSetSlidegroup.vue?vue&type=style&index=0&id=64a2bcb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a2bcb4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CreatorShopProductSetTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/product-set/ProductSetTile.vue').default,CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,CSlideItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSlideGroup/CSlideItem.vue').default,CLtkSlideGroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkSlideGroup/CLtkSlideGroup.vue').default})
